module.exports = __webpack_public_path__ + "img/minus_btn.00e66bfb.png";